import React from 'react';
import IconSort from 'src/assets/images/icons/sort.svg';
import { useColumnHeaderContext } from '../hooks/useColumnHeaderContext';

interface SortButtonProps {
  direction: 'asc' | 'desc';
}

export const SortButton: React.FC<SortButtonProps> = ({ direction }) => {
  const { sort } = useColumnHeaderContext();

  const text = direction === 'asc' ? sort.ascText : sort.descText;
  const isActive = sort.currentDirection === direction;

  return (
    <button
      type='button'
      onClick={() => sort.onApply(direction)}
      className={`normal-case py-10 px-8 text-12 lg:text-14 flex items-center gap-12 justify-between transition-all hover:bg-neutral-10 ${
        isActive ? 'bg-primary-10 text-primary font-medium' : 'text-neutral-80'
      }`}
    >
      <div className='flex items-center gap-12'>
        <img src={IconSort} alt={`Sort ${direction === 'asc' ? 'Ascending' : 'Descending'}`} className='h-16 w-16' />
        {text}
      </div>

      {isActive && (
        <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path d='M6.66675 10.7799L3.22008 7.33325L2.27341 8.27325L6.66675 12.6666L14.6667 4.66659L13.7267 3.72659L6.66675 10.7799Z' fill='#00992B' />
        </svg>
      )}
    </button>
  );
};
